import React, { Children, PropsWithChildren, ReactElement, ReactNode } from 'react';
import { Box } from '@hopskipdrive/react-components';

import { BreadcrumbsNav } from '../BreadcrumbsNav';
import { BreadcrumbsNavProps } from '../BreadcrumbsNav/BreadcrumbsNav';

import { Container, TitleText } from './ActionBar.styles';

interface ActionBarProps {
  children: ReactNode | ReactNode[];
  bgcolor?: string;
}
interface TitleProps {
  title?: ReactNode;
  className?: string;
}
interface SideControlsProps {
  children: ReactNode | ReactNode[];
}

interface IActionBar extends React.FC<ActionBarProps> {
  Title: React.FC<TitleProps>;
  Breadcrumbs: React.FC<BreadcrumbsNavProps>;
  SideControls: React.FC<SideControlsProps>;
}

const Title: React.FC<TitleProps> = ({ title, className }) => {
  return (
    <TitleText data-testid="page-title" variant="h1" className={className}>
      {title}
    </TitleText>
  );
};

const SideControls: React.FC<SideControlsProps> = ({ children }) => {
  return <>{children}</>;
};

export const ActionBar: IActionBar = ({ children, bgcolor }) => {
  return (
    <Container data-testid="action-bar" style={{ top: '38px' }} $bgcolor={bgcolor}>
      {Children.map(children, (child) => {
        const item = child as ReactElement<PropsWithChildren<BreadcrumbsNavProps | TitleProps>>;

        return item.type === BreadcrumbsNav ? <div style={{ paddingBottom: '1rem' }}>{item}</div> : null;
      })}
      <Box
        flexGrow={1}
        overflow="visible"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        minHeight="44px"
      >
        {Children.map(children, (child) => {
          const item = child as ReactElement<PropsWithChildren<BreadcrumbsNavProps | TitleProps>>;

          return item.type === Title || item.type === SideControls ? item : null;
        })}
      </Box>
    </Container>
  );
};

ActionBar.Title = Title;
BreadcrumbsNav.displayName = 'BreadcrumbsNav';
ActionBar.Breadcrumbs = BreadcrumbsNav;
ActionBar.SideControls = SideControls;
